import { AttentionItem } from '../interfaces/attentionItems';

const POSTGRES_LOGO_URL = 'https://cdn.hevo.io/external_logos/postgres.png';
const PGOUTPUT_DOCS_URL =
  'https://docs.hevodata.com/sources/dbfs/databases/postgresql/upgrading-pipelines-with-postgresql-sources-to-use-the-pgoutput-plugin';

const BIGQUERY_LOGO_URL = 'https://cdn.hevo.io/external_logos/bigquery.png';
const BQ_SERVICE_ACC_DOC_URL = 'https://docs.hevodata.com/destinations/data-warehouses/google-bigquery/modifying-bigquery-destinations-to-use-service-account-authentication'

export interface AttentionItemsSettings {
  showPubKeyMessageTeam: boolean;
  showBqServiceAccountMigration: boolean
}

/**
 * Static, data-driven list of "needs your attention" items.
 * Each item's `enabled` gate is computed from team settings.
 * Append new items (e.g. Edge, BigQuery migration) to this array following the same shape.
 */
export function getAttentionItems(settings: AttentionItemsSettings): AttentionItem[] {
  return [
    {
      id: 'pgoutput-upgrade',
      severity: 'warning',
      listLabel: 'Upgrade PostgreSQL Pipelines',
      title: 'Upgrade PostgreSQL Pipelines to Use pgoutput Plugin',
      body:
        'Hevo is upgrading Pipelines created with PostgreSQL Sources to use the pgoutput plugin ' +
        'for logical replication. To continue uninterrupted data replication, create a ' +
        'publication for the tables that you want to replicate from your database.',
      logoUrl: POSTGRES_LOGO_URL,
      banner: {
        color: 'primary',
        icon: 'info',
        text: 'This upgrade is mandatory for Pipelines using PostgreSQL Source.'
      },
      primaryCta: {
        label: 'Learn how to setup',
        url: PGOUTPUT_DOCS_URL
      },
      enabled: settings.showPubKeyMessageTeam
    },
    {
      id: 'bq-migration',
      severity: 'warning',
      listLabel: 'Modify BigQuery Destinations',
      logoUrl: BIGQUERY_LOGO_URL,
      title: 'Modify BigQuery Destinations to Use Service Account Authentication',
      body: 'Starting Sep 01, 2026, Hevo will discontinue support for user account authentication for Google BigQuery Destinations. Any Destinations using user account authentication after this date might stop replicating data. To avoid this, go to each affected Destination and modify the configuration to switch the authentication method to a service account. This change improves security and reliability as service accounts are not tied to individual users, ensuring that credential changes, password resets, or account deactivations do not interrupt data replication.',
      primaryCta: {
        label: 'Learn how to modify',
        url: BQ_SERVICE_ACC_DOC_URL
      },
      enabled: settings.showBqServiceAccountMigration
    }
  ];
}
